var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "work-space" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingData,
            expression: "loadingData"
          }
        ],
        staticClass: "all-loadPage"
      },
      [
        _c("div", { staticClass: "img-loading" }, [
          _c("img", {
            attrs: { src: require("../assets/images/loading.gif") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "load-size" }, [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("language.leftBanner.cloudEscription"))),
              _c("span", { staticClass: "dotting" })
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loadingData,
            expression: "!loadingData"
          }
        ],
        staticStyle: { width: "100%", height: "100%" }
      },
      [
        _vm.$store.state.beginGuideFlag
          ? _c("div", { staticClass: "beginGuideFlag" })
          : _vm._e(),
        _vm._v(" "),
        _c("leftBanner", { ref: "leftBanner" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right-larg-body",
            style: _vm.$i18n.locale == "spanish" ? "min-width: 1470Px;" : ""
          },
          [
            _c("rightContBan", { ref: "rightContBan" }),
            _vm._v(" "),
            _c(
              "keep-alive",
              { attrs: { include: ["taskList", "imageSaverTask"] } },
              [_c("router-view", { ref: "routView" })],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("changePasswordDialog", { ref: "changePass" }),
        _vm._v(" "),
        _c("bindEmailDialog", { ref: "bindEmail" }),
        _vm._v(" "),
        _c("changeNameDialog", { ref: "changeName" }),
        _vm._v(" "),
        _c("deleteAccountDialog", { ref: "deleteAccount" }),
        _vm._v(" "),
        _c("deleteAccountRemindDialog", { ref: "deleteAccountRemindDialog" }),
        _vm._v(" "),
        _c("subAccountDialog", { ref: "subAccount" }),
        _vm._v(" "),
        _c("limitedSaledDialog", { ref: "limitedSaledDialog" }),
        _vm._v(" "),
        _c("freeSaledFloating", { ref: "freeSaledFloating" }),
        _vm._v(" "),
        _c("payDiffDialog", { ref: "payDiffDialog" }),
        _vm._v(" "),
        _c("iosPayTipDialog", { ref: "iosPayTipDialog" }),
        _vm._v(" "),
        _c("appRecommendDialog", { ref: "appRecommendDialog" }),
        _vm._v(" "),
        _c("appRecommendMobileDialog", { ref: "appRecommendMobileDialog" }),
        _vm._v(" "),
        _c("paySys", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          ref: "paySys"
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0833c100", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0833c100","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mc_project.vue
// module id = null
// module chunks = 